import { useNavigate } from 'react-router-dom'
import TableFilter from './tableFilter'
import { useDispatch } from 'react-redux'
import { useState } from 'react'
import ExportButton from '../../common/ExportButton'
import { appPendingMembership } from '../../store/pendingmembers'
import { pendingMembershipExportColumns } from '../../config/exportColumns/pendingMembershipExportColumns'

function RequstedUser() {
	const dispatch = useDispatch()

	const hubId = localStorage.getItem('hubId')
	const permissionOfHub = localStorage.getItem('permissionOfHub')

	const [exportFilters, setExportFilters] = useState({})

	return (
		<>
			<div className="content-wrapper">
				<div className="content-heading d-flex justify-content-between">
					<div>Membership contribution approval</div>

					<ExportButton
						fetchAction={params =>
							dispatch(
								appPendingMembership({
									...params,
									...exportFilters,
									hub: hubId || permissionOfHub,
									limit: 10000,
								}),
							)
						}
						columns={pendingMembershipExportColumns}
						fileName="Pending_Memberships"
						sheetName="Pending Memberships"
						buttonText="Export Pending Members"
					/>
				</div>

				<TableFilter setExportFilters={setExportFilters} />
			</div>
		</>
	)
}

export default RequstedUser
